import React from 'react';
import moment from 'moment';
import { Modal, FormItem } from 'carbon-components-react';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { getDmService, getByDmService } from '../../../services/Api';
import CardTrade from './card-trade';
// import appConfig from '../../../config/app-config';
import { Breadcrumb, DatePicker } from '../../../components';
import { forceDownloadAsync } from '../../../lib/validations';

// const {IMAGE_PATH} = appConfig;

class Dashboard extends React.PureComponent {
  state = {
    openExport:false,
    brindes: {
      pendentes: 0,
      preparacao: 0,
      totalProntoEntrega: 0,
      prontoEntregaAte3Dias: 0,
      prontoEntregaAte5Dias: 0,
      prontoEntregaAte7Dias: 0,
      prontoEntregaAte10Dias: 0,
      prontoEntregaAcima10Dias: 0
    },
    pranchetas: {
      pendentes: 0,
      preparacao: 0,
      totalProntoEntrega: 0,
      prontoEntregaAte3Dias: 0,
      prontoEntregaAte5Dias: 0,
      prontoEntregaAte7Dias: 0,
      prontoEntregaAte10Dias: 0,
      prontoEntregaAcima10Dias: 0
    },
    campanhasPromocionais: {
      pendentes: 0,
      aprovados: 0,
      criacao: 0,
      produtocao: 0,
      transporte: 0
    },
    uniformes: {
      pendentes: 0,
      preparacao: 0,
      totalProntoEntrega: 0,
      prontoEntregaAte3Dias: 0,
      prontoEntregaAte5Dias: 0,
      prontoEntregaAte7Dias: 0,
      prontoEntregaAte10Dias: 0,
      prontoEntregaAcima10Dias: 0,
      aguardandoDevolucao: 0
    }
  };

  componentDidMount() {
    getDmService('/Dashboard/Trade').then(data => {
      // console.log(data);
      this.setState(data);
    });
  }

  openExelModal = () => {
    this.setState(prevState => ({
      openExport: !prevState.openExport,
    }));
  }
  
  onDateChange = (date, name) => {    
    const data = date == null ? "" : moment(date)
    this.setState({[name]: data });
  };
  
  exportExcel = async() => {
    const {DataInicial, DataFinal} = this.state;
    try {
      const data = await getByDmService('/Dashboard/ExportarTrade', `?DataInicial=${DataInicial ? moment(DataInicial).format("YYYY/MM/DD") : ""}&DataFinal=${DataFinal ? DataFinal.format("YYYY/MM/DD") : ""}`);
      forceDownloadAsync(data);
    } catch (error) {
      toast.error('Ocorreu uma falha ao gerar o arquivo');
    }
  }

  render() {
    const {
      brindes,
      pranchetas,
      campanhasPromocionais,
      uniformes,
      openExport,
      DataInicial, 
      DataFinal
    } = this.state;

    return (
      <div>
        <Breadcrumb
          title="Dashboard Trade" 
          description="" 
          renderRight={(
            <div className="flex v-sm-margin">
              <button
                className="bx--btn btn-secondary-color h-sm-margin"
                type="button"
                onClick={() => this.openExelModal()}
              >
                Exportar Excel
              </button>
            </div>
          )}
        />
        <section id="content">
          <div className="bx--grid">
            <div className="bx--row">
              <div className="bx--col-xs-12 bx--col-sm-12  bx--col-md-6">
                <CardTrade
                  title="Brindes"
                  data={[
                    { label: 'Pendentes', total: brindes.pendentes },
                    { label: 'Preparação', total: brindes.preparacao },
                    {
                      label: 'Pronto para Entrega (total)',
                      total: brindes.totalProntoEntrega,
                      featured: true
                    },
                    {
                      label: 'Pronto para Entrega até 3 dias',
                      total: brindes.prontoEntregaAte3Dias,
                      extra: true
                    },
                    {
                      label: 'Pronto para Entrega até 5 dias',
                      total: brindes.prontoEntregaAte5Dias,
                      extra: true
                    },
                    {
                      label: 'Pronto para Entrega até 7 dias',
                      total: brindes.prontoEntregaAte7Dias,
                      extra: true
                    },
                    {
                      label: 'Pronto para Entrega até 10 dias',
                      total: brindes.prontoEntregaAte10Dias,
                      extra: true
                    },
                    {
                      label: 'Pronto para Entrega acima de 10 dias',
                      total: brindes.prontoEntregaAcima10Dias,
                      extra: true
                    }
                  ]}
                />
                <CardTrade
                  title="Campanhas Promocionais"
                  data={[
                    {
                      label: 'Pendentes',
                      total: campanhasPromocionais.pendentes
                    },
                    {
                      label: 'Aprovados',
                      total: campanhasPromocionais.aprovados
                    },
                    { label: 'Criação', total: campanhasPromocionais.criacao },
                    {
                      label: 'Produção',
                      total: campanhasPromocionais.produtocao
                    },
                    {
                      label: 'Transporte',
                      total: campanhasPromocionais.transporte
                    }
                  ]}
                />
              </div>
              <div className="bx--col-xs-12 bx--col-sm-12  bx--col-md-6">
                <CardTrade
                  title="Pranchetas"
                  data={[
                    { label: 'Pendentes', total: pranchetas.pendentes },
                    { label: 'Preparação', total: pranchetas.preparacao },
                    {
                      label: 'Pronto para Entrega (total)',
                      total: pranchetas.totalProntoEntrega
                    }
                  ]}
                />
                <CardTrade
                  title="Uniformes"
                  data={[
                    { label: 'Pendentes', total: uniformes.pendentes },
                    { label: 'Preparação', total: uniformes.preparacao },
                    {
                      label: 'Pronto para Entrega (total)',
                      total: uniformes.totalProntoEntrega
                    },
                    {
                      label: 'Aguardando Devolução',
                      total: uniformes.aguardandoDevolucao
                    }
                  ]}
                />
              </div>
            </div>
          </div>
        </section>
        
        {openExport && (
          <Modal
            className="modal-dashboard-agencia"
            modalHeading="Exportar planilha"
            primaryButtonText="Exportar"
            secondaryButtonText="Cancelar"
            onRequestSubmit={() => this.exportExcel()}
            onRequestClose={() => this.openExelModal()}
            open={openExport}
          >
            <div>
              <p>Você pode exportar os dados de todo período ou filtar pela &#39;Data de solicitação&#39; preenchendo os campos abaixo.</p>
              <div className="bx--row">
                <div className="bx--col-md-6 bx--col-xs-6 bx--col-sm-6 calendar-dash-agency">
                  <FormItem className="v-sm-margin">
                    <label className="bx--label">De</label>
                    <DatePicker
                      id="DataInicial"
                      placeholder="Data Inicial"
                      date={DataInicial ? moment(DataInicial) : ""}
                      locale="pt"
                      onDateChange={(date) => this.onDateChange(date, 'DataInicial')}
                      readOnly
                      isOutsideRange={() => false}
                      showClearDate
                    />
                  </FormItem>
                </div>
                <div className="bx--col-md-6 bx--col-xs-6 bx--col-sm-6 calendar-dash-agency">
                  <FormItem className="v-sm-margin">
                    <label className="bx--label">Até</label>
                    <DatePicker
                      id="DataFinal"
                      placeholder="Data Final"
                      date={DataFinal ? moment(DataFinal) : ""}
                      locale="pt"
                      onDateChange={(date) => this.onDateChange(date, 'DataFinal')}
                      readOnly
                      isOutsideRange={() => false}
                      showClearDate
                    />
                  </FormItem>
                </div>
              </div>         
            </div>
          </Modal>
        )}
      </div>
    );
  }
}

export default connect()(Dashboard);



// WEBPACK FOOTER //
// ./src/screens/admin/Dashboard/trade.js